import {
  //
  ADD_APPOINTMENT,
  ADD_APPOINTMENT_FAILURE,
  ADD_APPOINTMENT_SUCCESS,
  //
  DELETE_APPOINTMENT,
  DELETE_APPOINTMENT_FAILURE,
  DELETE_APPOINTMENT_SUCCESS,
  //
  EDIT_APPOINTMENT,
  EDIT_APPOINTMENT_FAILURE,
  EDIT_APPOINTMENT_SUCCESS,
  //
  FETCH_APPOINTMENTS,
  FETCH_APPOINTMENTS_FAILURE,
  FETCH_APPOINTMENTS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
} from "./constants";

// List
export const fetchAppointments = (payload, onSuccess) => ({
  type: FETCH_APPOINTMENTS,
  payload,
  onSuccess,
});
export const fetchAppointmentsSuccess = (payload) => ({
  type: FETCH_APPOINTMENTS_SUCCESS,
  payload,
});
export const fetchAppointmentsFailure = (payload) => ({
  type: FETCH_APPOINTMENTS_FAILURE,
  payload,
});
// View
export const getViewData = (payload, onSuccess) => ({
  type: GET_VIEW_DATA,
  payload,
  onSuccess,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addAppointment = (payload, onAdd) => ({
  type: ADD_APPOINTMENT,
  payload,
  onAdd,
});
export const addAppointmentSuccess = (payload) => ({
  type: ADD_APPOINTMENT_SUCCESS,
  payload,
});
export const addAppointmentFailure = (payload) => ({
  type: ADD_APPOINTMENT_FAILURE,
  payload,
});
// EDIT
export const editAppointment = (payload, onEdit) => ({
  type: EDIT_APPOINTMENT,
  payload,
  onEdit,
});
export const editAppointmentSuccess = (payload, onEdit) => ({
  type: EDIT_APPOINTMENT_SUCCESS,
  payload,
});
export const editAppointmentFailure = (payload) => ({
  type: EDIT_APPOINTMENT_FAILURE,
  payload,
});
// DELETE
export const deleteAppointment = (payload, onDelete) => ({
  type: DELETE_APPOINTMENT,
  payload,
  onDelete,
});
export const deleteAppointmentSuccess = (payload) => ({
  type: DELETE_APPOINTMENT_SUCCESS,
  payload,
});
export const deleteAppointmentFailure = (payload) => ({
  type: DELETE_APPOINTMENT_FAILURE,
  payload,
});
